<div class="d-flex justify-content-end me-4">
  <div class="p-2">
    <button type="button" class="btn btn-light text-dark" (click)="logout()">
      Sign Out
    </button>
  </div>
</div>
